import { SVG } from '../SVG'

const FacultyIcon = ({ style = {}, ...props }) => (
  <SVG
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    style={{ fill: 'var(--svg-darker-fill)', ...style }}
    {...props}
  >
    <path d='M9.91658 3.50065C9.91658 5.11148 8.61075 6.41732 6.99992 6.41732C5.38909 6.41732 4.08325 5.11148 4.08325 3.50065C4.08325 1.88982 5.38909 0.583984 6.99992 0.583984C8.61075 0.583984 9.91658 1.88982 9.91658 3.50065Z' />
    <path
      opacity='0.25'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.9772 8.23869C10.6176 7.82179 9.99998 7.84327 9.51705 8.1076C8.76973 8.51665 7.91202 8.7492 7 8.7492C6.08798 8.7492 5.23027 8.51665 4.48295 8.1076C4.00001 7.84327 3.38241 7.82179 3.02284 8.23869C2.22963 9.15835 1.75 10.3561 1.75 11.6659V12.2492C1.75 12.8935 2.27233 13.4159 2.91667 13.4159H11.0833C11.7277 13.4159 12.25 12.8935 12.25 12.2492V11.6659C12.25 10.3561 11.7704 9.15835 10.9772 8.23869Z'
    />
  </SVG>
)

export default FacultyIcon
